export default __webpack_public_path__ + "static/in-app-payment-ae664db71605c837dd8971e10873e0c1.jpg";